import { cva, VariantProps } from 'class-variance-authority';

export const typography = cva(['leading-normal'], {
  variants: {
    intent: {
      display: ['text-[2rem]', 'sm:text-[3rem]', 'md:text-[3.5rem]'],
      headline: [],
      title: [],
      label: [],
      body: [],
      button: ['text-sm'],
    },
    size: {
      sm: [],
      md: [],
      lg: [],
      xl2: [],
    },
    weight: {
      light: [],
      normal: [],
      medium: [],
      semibold: [],
      bold: [],
      default: [],
    },
    // color setting
    color: {
      default: ['text-inherit'],
      white: ['text-white'],
    },
    gutter: {
      true: [],
      false: [],
    },
  },
  compoundVariants: [
    {
      intent: 'headline',
      size: 'sm',
      className: ['text-[1.75rem]'],
    },
    {
      intent: 'headline',
      size: 'md',
      className: ['text-[2rem]'],
    },
    {
      intent: 'headline',
      size: 'lg',
      className: ['text-3xl sm:text-6xl mb-4 sm:mb-6 font-semibold'],
    },
    {
      intent: 'headline',
      size: 'xl2',
      className: ['text-4xl', 'leading-tight'],
    },
    {
      intent: 'title',
      size: 'sm',
      className: ['text-[1rem]'],
    },
    {
      intent: 'title',
      size: 'md',
      className: ['text-[1.25rem]'],
    },
    {
      intent: 'title',
      size: 'lg',
      className: ['text-[1.5rem]'],
    },
    {
      intent: 'label',
      size: 'sm',
      className: ['text-[0.625rem]'],
    },
    {
      intent: 'label',
      size: 'md',
      className: ['text-[0.75rem]'],
    },
    {
      intent: 'label',
      size: 'lg',
      className: ['text-[0.875rem]'],
    },
    {
      intent: 'body',
      size: 'sm',
      className: ['text-[0.75rem]'],
    },
    {
      intent: 'body',
      size: 'md',
      className: ['text-[0.875rem]'],
    },
    {
      intent: 'body',
      size: 'lg',
      className: ['text-[1rem]'],
    },
    {
      intent: ['display'],
      weight: 'default',
      className: ['font-medium'],
    },
    {
      intent: ['headline', 'title', 'button'],
      weight: 'default',
      className: ['font-medium'],
    },
    {
      intent: ['body'],
      weight: 'default',
      className: ['font-normal'],
    },
    {
      intent: ['label'],
      weight: 'bold',
      className: ['text-blue-800'],
    },
    {
      weight: 'light',
      className: ['font-light'],
    },
    {
      weight: 'normal',
      className: ['font-normal'],
    },
    {
      weight: 'medium',
      className: ['font-medium'],
    },
    {
      weight: 'semibold',
      className: ['font-semibold'],
    },
    {
      weight: 'bold',
      className: ['font-bold'],
    },
    {
      intent: ['body', 'label'],
      gutter: true,
      className: 'pb-3',
    },
    {
      intent: ['title', 'headline', 'display'],
      gutter: true,
      className: 'pb-8',
    },
  ],
  defaultVariants: {
    intent: 'body',
    weight: 'default',
    size: 'lg',
  },
});

export type Weights = 'light' | 'normal' | 'medium' | 'semibold' | 'bold';

export type StyleProps = Partial<
  Omit<VariantProps<typeof typography>, 'weight'> & {
    weight?: Weights;
  }
>;
